/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxNumberInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxnumberinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcNumberInputComponent),
    multi: true
};

/**
 * Number Input
 */
@Component({
    selector: 'ngc-numberinput',
    template: `<jqxNumberInput *ngIf="visible" (onChange)="inputChange($event)"
                [allowNull] = "allowNull"
                [decimal] = "decimal"
                [disabled] = "disabled"
                [decimalDigits] = "decimalDigits"
                [decimalSeparator] = "decimalSeparator"
                [digits] = "digits"
                [groupSeparator] = "groupSeparator"
                [groupSize] = "groupSize"
                [inputMode] = "inputMode"
                [min] = "min"
                [max] = "max"
                [negativeSymbol] = "negativeSymbol"
                [placeHolder] = "placeHolder"
                [promptChar] = "promptChar"
                [rtl] = "rtl"
                [readOnly] = "readOnly"
                [spinMode] = "spinMode"
                [spinButtons] = "spinButtons"
                [spinButtonsWidth] = "spinButtonsWidth"
                [spinButtonsStep] = "spinButtonsStep"
                [symbol] = "symbol"
                [symbolPosition] = "symbolPosition"
                [textAlign] = "textAlign"
                [template] = "template"
                [theme] = "theme"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                </jqxNumberInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcNumberInputComponent extends ControlComponent {
    @Input('allowNull') allowNull: any;
    @Input('decimal') decimal: any;
    @Input('decimalDigits') decimalDigits: any;
    @Input('decimalSeparator') decimalSeparator: any;
    @Input('digits') digits: any;
    @Input('groupSeparator') groupSeparator: any;
    @Input('groupSize') groupSize: any;
    @Input('inputMode') inputMode: any;
    @Input('min') min: any;
    @Input('max') max: any;
    @Input('negativeSymbol') negativeSymbol: any;
    @Input('placeHolder') placeHolder: any;
    @Input('promptChar') promptChar: any;
    @Input('rtl') rtl: any;
    @Input('readOnly') readOnly: any;
    @Input('spinMode') spinMode: any;
    @Input('spinButtons') spinButtons: any;
    @Input('spinButtonsWidth') spinButtonsWidth: any;
    @Input('spinButtonsStep') spinButtonsStep: any;
    @Input('symbol') symbol: any;
    @Input('symbolPosition') symbolPosition: any;
    @Input('textAlign') textAlign: any;
    @Input('template') template: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.args.value;
    }
}

/**
 * Number Input Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcNumberInputComponent],
    declarations: [NgcNumberInputComponent, jqxNumberInputComponent]
})
export class NgcNumberInputModule {
}